import styles from "./blog.module.css";
import { AiOutlineLeft } from "react-icons/ai";
import { BsBorderAll } from "react-icons/bs";
import { RiCurrencyLine } from "react-icons/ri";
import { RiFundsBoxLine } from "react-icons/ri";
import { BiBitcoin } from "react-icons/bi";
import img524 from "assets/images/img524.svg";
import ax1 from "../../assets/images/ax1.svg";
import ax2 from "../../assets/images/ax2.svg";
import ax3 from "../../assets/images/ax3.svg";
import ax4 from "../../assets/images/report.svg";
import pic5 from "../../assets/images/pic5.svg";
import pic6 from "../../assets/images/pic6.svg";
import pic7 from "../../assets/images/pic7.svg";
import pic8 from "../../assets/images/pic8.svg";
import bit1 from "../../assets/images/bit1.svg";
import bit2 from "../../assets/images/bit2.svg";
import bit3 from "../../assets/images/bit3.svg";
import bit4 from "../../assets/images/bit4.svg";
import SwiperCore, { Autoplay } from "swiper";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
const Blog = () => {
  SwiperCore.use([Navigation, Autoplay]);
  return (
    <div>
      <div className={styles.grayPage}>
        <div
          className={`   justify-content-evenly m-auto  ${styles.widthHotest} `}
        >
          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            observer={true}
            loop={true}
            observeParents={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
            breakpoints={{
              // when window width is >= 320px

              400: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              // when window width is >= 535px
              429: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              700: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              // when window width is >= 992px
              992: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1200: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
            }}
            key={Math.random() * 50}
          >
            <SwiperSlide
              className={`d-flex flex-column my-5 justify-content-evenly align-items-center text-light ${styles.cryptCardx} `}
            >
              <img src={ax4} className={styles.ax1} />
              <div className={styles.up}>
                <div className="d-flex justify-content-evenly">
                  <img src={img524} className={styles.img524} />
                  <div className=" d-flex flex-column justify-content-around">
                    <div className=" d-flex flex-column justify-content-evenly align-items-end">
                      <h4>چگونه اتریوم بخریم ؟</h4>
                      <h4>آموزش خرید اتریوم</h4>
                      <div className={`text-center ${styles.leftIcon}`}>
                        <AiOutlineLeft />
                      </div>
                    </div>
                    <div
                      className=" d-flex  justify-content-around"
                      style={{ fontSize: "13px" }}
                    >
                      <p>نیما ملک پور</p>
                      <p>4 ماه پیش</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide
              className={`d-flex flex-column my-5  justify-content-evenly align-items-center text-light ${styles.cryptCard2x} `}
            >
              <img src={ax1} className={styles.ax1} />
              <div className={styles.up}>
                <div className="d-flex justify-content-evenly">
                  <img src={img524} className={styles.img524} />
                  <div className=" d-flex flex-column justify-content-around">
                    <div className=" d-flex flex-column justify-content-evenly align-items-end">
                      <h4>چگونه اتریوم بخریم ؟</h4>
                      <h4>آموزش خرید اتریوم</h4>
                      <div className={`text-center ${styles.leftIcon}`}>
                        <AiOutlineLeft />
                      </div>
                    </div>
                    <div
                      className=" d-flex  justify-content-around"
                      style={{ fontSize: "13px" }}
                    >
                      <p>نیما ملک پور</p>
                      <p>4 ماه پیش</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className={`d-flex flex-column my-5 justify-content-evenly align-items-center text-light ${styles.cryptCard3x} `}
            >
              <img src={ax2} className={styles.ax1} />
              <div className={styles.up}>
                <div className="d-flex justify-content-evenly">
                  <img src={img524} className={styles.img524} />
                  <div className=" d-flex flex-column justify-content-around">
                    <div className=" d-flex flex-column justify-content-evenly align-items-end">
                      <h4>چگونه اتریوم بخریم ؟</h4>
                      <h4>آموزش خرید اتریوم</h4>
                      <div className={`text-center ${styles.leftIcon}`}>
                        <AiOutlineLeft />
                      </div>
                    </div>
                    <div
                      className=" d-flex  justify-content-around"
                      style={{ fontSize: "13px" }}
                    >
                      <p>نیما ملک پور</p>
                      <p>4 ماه پیش</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className={`d-flex flex-column my-5 justify-content-evenly align-items-end text-light ${styles.cryptCard4x} `}
            >
              <img src={ax3} className={styles.ax1} />
              <div className={styles.up}>
                <div className="d-flex justify-content-evenly">
                  <img src={img524} className={styles.img524} />
                  <div className=" d-flex flex-column justify-content-around">
                    <div className=" d-flex flex-column justify-content-evenly align-items-end">
                      <h4>چگونه اتریوم بخریم ؟</h4>
                      <h4>آموزش خرید اتریوم</h4>
                      <div className={`text-center ${styles.leftIcon}`}>
                        <AiOutlineLeft />
                      </div>
                    </div>
                    <div
                      className=" d-flex  justify-content-around"
                      style={{ fontSize: "13px" }}
                    >
                      <p>نیما ملک پور</p>
                      <p>4 ماه پیش</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <div className="swiper-button-next "></div>
            <div className="swiper-button-prev "></div>
          </Swiper>
        </div>
        <div className={`m-auto ${styles.widthHotest}`}>
          <ul class="nav nav-pills ">
            <li class="nav-item" role="presentation">
              <button
                className={`nav-link active ${styles.activeLink}`}
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                <BsBorderAll />
                همه
              </button>
            </li>

            <li class="nav-item">
              <a class="nav-link text-dark" href="#">
                <RiCurrencyLine />
                ارز دیجیتال
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark" href="#">
                <BiBitcoin />
                بلاک چین
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark" href="#">
                <RiFundsBoxLine />
                سرمایه گذاری
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <div className={`m-auto mt-4  ${styles.widthHotest}`}>
            {" "}
            <h5 className={styles.newsText}> آخرین اخبار</h5>
          </div>
          <div
            className={`   justify-content-evenly m-auto  ${styles.widthHotest}`}
          >
            <Swiper
              spaceBetween={10}
              slidesPerView={1}
              loop={true}
              observer={true}
              observeParents={true}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              autoplay={{ delay: 1000, pauseOnMouseEnter: true }}
              breakpoints={{
                // when window width is >= 320px

                400: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                // when window width is >= 535px
                429: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                700: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                // when window width is >= 992px
                992: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
              }}
              key={Math.random() * 50}
            >
              <div className="swiper-button-prev "></div>
              <div className="swiper-button-next "></div>
              <SwiperSlide
                className={`d-flex flex-column my-5 justify-content-evenly align-items-center text-light ${styles.cryptCard} ${styles.point}`}
              >
                <img src={ax4} className={styles.ax1} />
                <div className={styles.up}>
                  <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
                  <div className="d-flex justify-content-around flex-column h-50 w-100">
                    <p className={`mx-2 ${styles.fontDigi}`}>
                      گذاران در سال ۲۰۲۱ تبدیل{" "}
                    </p>
                    <div className="d-flex justify-content-around w-100">
                      <small className={` ${styles.fontSm}`}>
                        نیما ملک پور
                      </small>
                      <small className={` ${styles.fontSm}`}>
                        <bdi>3</bdi>
                        ساعت پیش
                      </small>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className={`d-flex flex-column my-5  justify-content-evenly align-items-center text-light ${styles.cryptCard2} ${styles.point} `}
              >
                <img src={ax1} className={styles.ax1} />
                <div className={styles.up}>
                  <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
                  <div className="d-flex justify-content-around flex-column h-50 w-100">
                    <p className={`mx-2 ${styles.fontDigi}`}>
                      رشد رمزار‌ها و استخراج بیت کوین با انرژی آتش‌فشان در
                      السالوادور
                    </p>
                    <div className="d-flex justify-content-around w-100">
                      <small className={styles.fontSm}>نیما ملک پور</small>
                      <small className={styles.fontSm}>
                        <bdi>3</bdi>
                        ساعت پیش
                      </small>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className={`d-flex flex-column my-5 justify-content-evenly align-items-center text-light ${styles.cryptCard3} ${styles.point}`}
              >
                <img src={ax2} className={styles.ax1} />
                <div className={styles.up}>
                  <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
                  <div className="d-flex justify-content-around flex-column h-50 w-100">
                    <p className={`mx-2 ${styles.fontDigi}`}>
                      رشد چشمگیر ارزهای دیجیتال در ۱ اکتبر
                    </p>
                    <div className="d-flex justify-content-around w-100">
                      <small className={styles.fontSm}>نیما ملک پور</small>
                      <small className={styles.fontSm}>
                        <bdi>3</bdi>
                        ساعت پیش
                      </small>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className={`d-flex flex-column my-5 justify-content-evenly align-items-end text-light ${styles.cryptCard4} ${styles.point} `}
              >
                <img src={ax3} className={styles.ax1} />
                <div className={styles.up}>
                  <div className="d-flex justify-content-around flex-column h-50 w-100"></div>
                  <div className="d-flex justify-content-around flex-column h-50 w-100">
                    <p className={`mx-2 ${styles.fontDigi}`}>
                      رشد چشمگیر ارزهای دیجیتال در ۱ اکتبر
                    </p>
                    <div className="d-flex justify-content-around w-100">
                      <small className={styles.fontSm}>نیما ملک پور</small>
                      <small className={styles.fontSm}>
                        <bdi>3</bdi>
                        ساعت پیش
                      </small>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          <div className={`m-auto mb-3 ${styles.widthHotest}`}>
            {" "}
            <h5 className={styles.newsText}> مطالب منتخب</h5>
          </div>

          <div className={`m-auto mb-5 ${styles.widthHotest}`}>
            <div className="row">
              <div
                className={`col-lg-3 col-sm-6 text-center mt-4 ${styles.dividerP}`}
              >
                <div>
                  <img src={pic5} className={styles.pic5} />
                  <div
                    style={{
                      width: "90%",
                      height: "90px",
                      overflow: "hidden",
                      margin: "auto",
                      display: "-webkit-box",
                      WebkitLineClamp: "3",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    <p className="m-auto mx-4">
                      شش اشتباه رایج در تحلیل تکنیکال که نباید مرتکب شد
                    </p>
                  </div>
                </div>

                <button
                  className={`my-2 py-1 text-danger border border-danger rounded ${styles.edame}`}
                >
                  ادامه مطالب
                </button>
              </div>

              <div
                className={`col-lg-3 col-sm-6 text-center mt-4 ${styles.dividerP1}`}
              >
                <img src={pic6} className={styles.pic5} />

                <div
                  style={{
                    width: "90%",
                    height: "90px",
                    overflow: "hidden",
                    margin: "auto",
                    display: "-webkit-box",
                    WebkitLineClamp: "3",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  <p className="m-auto mx-4 ">
                    چگونه یک تریدر موفق شویم؟ توصیه‌هایی از زبان کارکشته‌های
                    بازار
                  </p>
                </div>

                <button
                  className={`my-2 py-1 text-danger border border-danger rounded ${styles.edame}`}
                >
                  ادامه مطالب
                </button>
              </div>
              <div
                className={`col-lg-3 col-sm-6 text-center mt-4 ${styles.dividerP2}`}
              >
                <img src={pic7} className={styles.pic5} />
                <div
                  style={{
                    width: "90%",
                    height: "90px",
                    overflow: "hidden",
                    margin: "auto",
                    display: "-webkit-box",
                    WebkitLineClamp: "3",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  <p className="m-auto mx-4">
                    ذخیره ارزش چیست؟ بیت‌کوین یک ذخیره ارزش
                  </p>
                </div>

                <button
                  className={`my-2 py-1 text-danger border border-danger rounded ${styles.edame}`}
                >
                  ادامه مطالب
                </button>
              </div>
              <div className="col-lg-3 col-sm-6 text-center mt-4">
                <img src={pic8} className={styles.pic5} />
                <div
                  style={{
                    width: "90%",
                    margin: "auto",
                    height: "90px",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: "3",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  <p className="m-auto mx-4">
                    تحلیل بنیادین چیست؟ راهنمای جامع
                  </p>
                </div>

                <button
                  className={`my-2 py-1 text-danger border border-danger rounded ${styles.edame}`}
                >
                  ادامه مطالب
                </button>
              </div>
            </div>
          </div>
          <div className="m-auto mb-4 w-100 d-flex justify-content-center">
            <button className={` rounded text-light  ${styles.more}`}>
              {" "}
              دیدن مطالب بیشتر
            </button>
          </div>
          <div className={`m-auto mb-3 ${styles.widthHotest}`}>
            {" "}
            <h5 className={styles.newsText}> مفاهیم پایه </h5>
          </div>
          <div className={`m-auto mb-5 ${styles.widthHotest}`}>
            <div className="row">
              <div
                className={`col-lg-3 col-sm-6 text-center  mt-4 ${styles.cardP}`}
              >
                <div className={styles.cardStyle}>
                  <img src={bit1} className={styles.pic5} />
                  <h5 className="mt-3">ارز دیجیتال چیست؟</h5>
                  <div className="d-flex mt-3 justify-content-evenly w-75 m-auto">
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      نیما ملک پور
                    </p>
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      ماه پیش <bdi>4</bdi>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "90%",
                      height: "70px",
                      overflow: "hidden",
                      margin: "auto",
                      display: "-webkit-box",
                      WebkitLineClamp: "3",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    <p
                      className="mt-1 mx-4"
                      style={{ fontSize: "14px", color: "gray" }}
                    >
                      ارز دیجیتال (Cryptocurrency) شکل خاصی از پول دیجیتال است
                      که بر پایه علم رمزنگاری ایجاد شده است{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`col-lg-3 col-sm-6  text-center mt-4 ${styles.cardP}`}
              >
                <div className={styles.cardStyle}>
                  <img src={bit2} className={styles.pic5} />
                  <h5 className="mt-3">ارز دیجیتال چیست؟</h5>
                  <div className="d-flex mt-3 justify-content-evenly w-75 m-auto">
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      نیما ملک پور
                    </p>
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      ماه پیش <bdi>4</bdi>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "90%",
                      height: "70px",
                      overflow: "hidden",
                      margin: "auto",
                      display: "-webkit-box",
                      WebkitLineClamp: "3",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    <p
                      className="mt-1 mx-4"
                      style={{ fontSize: "14px", color: "gray" }}
                    >
                      ارز دیجیتال (Cryptocurrency) شکل خاصی از پول دیجیتال است
                      که بر پایه علم رمزنگاری ایجاد شده است{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={`col-lg-3 col-sm-6  text-center mt-4 ${styles.cardP}`}
              >
                <div className={styles.cardStyle}>
                  <img src={bit3} className={styles.pic5} />
                  <h5 className="mt-3">ارز دیجیتال چیست؟</h5>
                  <div className="d-flex mt-3 justify-content-evenly w-75 m-auto">
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      نیما ملک پور
                    </p>
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      ماه پیش <bdi>4</bdi>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "90%",
                      height: "70px",
                      overflow: "hidden",
                      margin: "auto",
                      display: "-webkit-box",
                      WebkitLineClamp: "3",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    <p
                      className="mt-1 mx-4"
                      style={{ fontSize: "14px", color: "gray" }}
                    >
                      ارز دیجیتال (Cryptocurrency) شکل خاصی از پول دیجیتال است
                      که بر پایه علم رمزنگاری ایجاد شده است{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={`col-lg-3 col-sm-6 text-center mt-4 ${styles.cardP}`}
              >
                <div className={styles.cardStyle}>
                  <img src={bit4} className={styles.pic5} />
                  <h5 className="mt-3">ارز دیجیتال چیست؟</h5>
                  <div className="d-flex mt-3 justify-content-evenly w-75 m-auto">
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      نیما ملک پور
                    </p>
                    <p className="text-muted" style={{ fontSize: "12px" }}>
                      ماه پیش <bdi>4</bdi>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "90%",
                      height: "70px",
                      overflow: "hidden",
                      margin: "auto",
                      display: "-webkit-box",
                      WebkitLineClamp: "3",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    <p
                      className="mt-1 mx-4"
                      style={{ fontSize: "14px", color: "gray" }}
                    >
                      ارز دیجیتال (Cryptocurrency) شکل خاصی از پول دیجیتال است
                      که بر پایه علم رمزنگاری ایجاد شده است{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="m-auto mb-5 w-100 d-flex justify-content-center">
            <button className={` rounded text-light  ${styles.more}`}>
              {" "}
              دیدن مطالب بیشتر
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;

{
  /* <div className={styles.slideBox}>
          <div className={styles.center1}>
            <img src={img524} className={styles.img524} />
            <div className=" d-flex flex-column justify-content-around">
              <div className=" d-flex flex-column justify-content-evenly align-items-end">
                <h4>چگونه اتریوم بخریم ؟</h4>
                <h4>آموزش خرید اتریوم</h4>
                <div className={`text-center ${styles.leftIcon}`}>
                  <AiOutlineLeft />
                </div>
              </div>
              <div className=" d-flex  justify-content-around">
                <p>نیما ملک پور</p>
                <p>4 ماه پیش</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.slideBox2}>
          <div className={styles.center}>
            <div className=" d-flex flex-column justify-content-around mx-5">
              <div className=" d-flex flex-column justify-content-evenly align-items-end">
                <h4>چگونه اتریوم بخریم ؟</h4>
                <h4>آموزش خرید اتریوم</h4>
                <div className={`text-center ${styles.leftIcon}`}>
                  <AiOutlineLeft />
                </div>
              </div>
              <div className=" d-flex  justify-content-around">
                <p>نیما ملک پور</p>
                <p>4 ماه پیش</p>
              </div>
            </div>
          </div>
        </div> */
}
